import { useQuery } from '@tanstack/react-query';
import { useApiClient } from './useApiClient'; // 共通のapiClientをインポート
import type { GetItemsFilters } from '../types';
import qs from 'qs';

export const useBiddingInfoPdfUrlQuery = (filters: GetItemsFilters, options?: { enabled?: boolean }) => {
  const apiClient = useApiClient(); // インスタンスを取得

  return useQuery({
    queryKey: ['reports', 'result-pdf', filters],
    queryFn: async () => {

      const cleanFilters = Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v != null && v !== '')
      );
      const queryString = qs.stringify(cleanFilters, { arrayFormat: 'repeat' });

      // 1. 共通設定済みのapiClientを使用する
      const response = await apiClient.get(`/reports/InfoList?${queryString}`, {
        responseType: 'blob',  // バイナリ取得を明示
        // ヘッダーを上書きしてJSON固定を解除（必要に応じて）
        headers: {
          'Accept': 'application/pdf',
        }
      });

      // 2. レスポンスがHTML（メニュー画面等）になっていないかチェック
      if (response.data.type === 'text/html' || response.data.type === 'application/json') {
        throw new Error("PDFの取得に失敗しました。セッションを確認してください。");
      }

      return URL.createObjectURL(response.data);
    },
    enabled: options?.enabled,
    staleTime: 0,
    gcTime: 0,
  });
};

export const useBiddingResultPdfUrlQuery = (filters: GetItemsFilters, options?: { enabled?: boolean }) => {
  const apiClient = useApiClient(); // インスタンスを取得

  return useQuery({
    queryKey: ['reports', 'result-pdf', filters],
    queryFn: async () => {
      const cleanFilters = Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v != null && v !== '')
      );
      const queryString = qs.stringify(cleanFilters, { arrayFormat: 'repeat' });
      // 1. 共通設定済みのapiClientを使用する
      const response = await apiClient.get(`/reports/ResultList?${queryString}`, {
        responseType: 'blob',  // バイナリ取得を明示
        // ヘッダーを上書きしてJSON固定を解除（必要に応じて）
        headers: {
          'Accept': 'application/pdf',
        }
      });

      // 2. レスポンスがHTML（メニュー画面等）になっていないかチェック
      if (response.data.type === 'text/html' || response.data.type === 'application/json') {
        throw new Error("PDFの取得に失敗しました。セッションを確認してください。");
      }

      return URL.createObjectURL(response.data);
    },
    enabled: options?.enabled,
    staleTime: 0,
    gcTime: 0,
  });
};